export var browserDefaultSize = 16;
export var defaultFontSize = 22;